import { Modal } from "react-bootstrap";
import Alert from "../../../components/Alert";
import { SidebarGlobal } from "../../../components/Bridge/Sidebar";
import Icon from "../../../components/Icon";
import L from "../../../components/Lang";
import { Pop } from "../../../components/PopModal";
import DataView from "../../../components/Solusek/DataView";
import APICom from "../components/APICom";

export default class LabOrderList extends APICom {

    constructor(props) {
        super(props);
        this.state = {
            query: {}
        };
    }

    async componentDidMount() {
        await this.loadAPIClients(true);
    }

    async componentDidUpdate(prevProps, prevState) {
        if(this.state.currentClient !== prevState.currentClient) {
            this.rehash();
        }
    }

    componentWillUnmount() {
        SidebarGlobal.clearSubNav();
    }

    simulate = (row) => {
        // TODO
        //Pop.show(<L>Under Development</L>, <L>Status simulation still under development.</L>);

        this.setState({ currentItem: row, showSimulate: true })
    }


    doSimulate = async (status) => {
        if(!this.state.currentClient) {
            this.alert('Please select a client.');
            return;
        }
        let j = await this.apiPost('/api/lab/order/simulate?status=' + status + '&apiClientID=' + this.state.currentClient.id, this.state.currentItem);
        if(j.item) {
            this.success('Simulation done.');
            this.setState({ currentItem: null, showSimulate: false });
            this.rehash();
        }
        else
            this.alert(j.errorMessage);
    }

    render() {
        return (
            <div className="container-fluid">
                <h1><L>Lab Order Sandbox</L></h1>
                {this.state.currentClient ? <div>
                    <p className="text-muted"><L>Sandbox shows latest 100 records.</L></p>
                    <DataView api={'/api/lab/order/list?apiClientID=' + this.state.currentClient.id} hash={this.state.hash}
                
                        conditionals={[
                            {
                                condition: (row) => row.status !== 'FINAL',
                                contentFunc: (row) => <button type="button" className="btn btn-success" onClick={() => this.simulate(row)}>SIMULATE</button>
                            }
                        ]} />
                </div> : <div className="lead"><Icon icon="faInfoCircle" /> <L>Please select Client in the top right of the screen.</L></div>}

                <Modal show={this.state.showSimulate} onHide={() => this.setState({ showSimulate: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title><L>Simulate</L></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-grid gap-1">
                            <button type="button" className="btn btn-primary" onClick={() => this.doSimulate('READY')}><L>Ready to Test</L> <i><L>(Received by Lab)</L></i></button>
                            <button type="button" className="btn btn-success" onClick={() => this.doSimulate('FINAL')}><L>Result Final</L> <i><L>(Finalized by Lab)</L></i></button>
                            <button type="button" className="btn btn-danger" onClick={() => this.doSimulate('CANCELED')}><L>Order Cancel</L> <i><L>(Canceled by Lab)</L></i></button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}